import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const GetAuditLogs = (params?: any) =>
    request({
        url: ApiURL.Query.GetAuditLogs,
        method: RequestType.GET,
        params: params,
    });

const AuditLogsQuery = {
    GetAuditLogs,
};

export default AuditLogsQuery;
